import { RailwayAlert } from "./railway_alert";
import { RealEstateAgent } from "./real_estate_agent";
import { ReceiptLong } from "./receipt_long";
import { Recommend } from "./recommend";
import { ReportProblem } from "./report_problem";
import { Restaurant } from "./restaurant";
import { Room } from "./room";

const iconsList = [
  { label: "RailwayAlert", code: <RailwayAlert /> },
  { label: "RealEstateAgent", code: <RealEstateAgent /> },
  { label: "ReceiptLong", code: <ReceiptLong /> },
  { label: "Recommend", code: <Recommend /> },
  { label: "ReportProblem", code: <ReportProblem /> },
  { label: "Restaurant", code: <Restaurant /> },
  { label: "Room", code: <Room /> },
];

export {
  iconsList,
  RailwayAlert,
  RealEstateAgent,
  ReceiptLong,
  Recommend,
  ReportProblem,
  Restaurant,
  Room,
};
